// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"dS","reco":"eS","products":"fS"};